'use strict';

class CTextAreaController{
  constructor(){
    'ngInject';
  }
  $onInit(){

  }
}
export default CTextAreaController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components/c-textarea/c-textarea.controller.js